import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_FINANCIAL_REPORTS](state, data) {
    state.allFinancialReports = data
  },
}
